import React from 'react';
import {ForecastTooltipFormulaRenderer} from '../../../components/ForecastTooltipFormulaRenderer';
import Util from '../../../forecast-app/shared/util/util';

const getPerformanceModifiedEstimate = (estimate, performance, intl) => {
	const modifiedEstimate = performance > 0 ? estimate / performance : 0;
	const roundedModifiedEstimate = Math.round((modifiedEstimate + 7) / 15) * 15;
	return Util.convertMinutesToFullHour(roundedModifiedEstimate, intl);
};

const getFocusModifiedEstimate = (estimate, focus, intl) => {
	const modifiedEstimate = focus > 0 ? estimate * focus : 0;
	const roundedModifiedEstimate = Math.round((modifiedEstimate + 7) / 15) * 15;
	return Util.convertMinutesToFullHour(roundedModifiedEstimate, intl);
};

export const getPerformanceRollingTooltipContent = (performanceRolling, intl) => {
	const performanceRollingFormatted = intl.formatNumber(performanceRolling * 100) + '%';
	return (
		<ForecastTooltipFormulaRenderer
			items={[
				{
					description: `Based on the last 30 days, task performance is ${performanceRollingFormatted}.`,
				},
				{
					description: `As an example, a task estimated at 10h was taking around ${getPerformanceModifiedEstimate(
						600,
						performanceRolling,
						intl
					)} to complete.`,
				},
			]}
			translatedMessage={true}
		/>
	);
};

export const getPerformanceTotalTooltipContent = (performanceTotal, intl) => {
	const performanceTotalFormatted = intl.formatNumber(performanceTotal * 100) + '%';
	return (
		<ForecastTooltipFormulaRenderer
			items={[
				{
					description: `The average task performance on this project is ${performanceTotalFormatted}.`,
				},
				{
					description: `As an example, a task estimated at 10h was taking around ${getPerformanceModifiedEstimate(
						600,
						performanceTotal,
						intl
					)} to complete.`,
				},
			]}
			translatedMessage={true}
		/>
	);
};

export const getFocusRollingTooltipContent = (focusRolling, intl) => {
	const focusRollingFormatted = intl.formatNumber(focusRolling * 100) + '%';
	return (
		<ForecastTooltipFormulaRenderer
			items={[
				{
					description: `Based on the last 30 days, your team focus is ${focusRollingFormatted}.`,
				},
				{
					description: `As an example, if the team was allocated 100h to the project, they registered around ${getFocusModifiedEstimate(
						6000,
						focusRolling,
						intl
					)}.`,
				},
			]}
			translatedMessage={true}
		/>
	);
};
